import { Component, Input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface BreakdownStats {
  testsTaken?: number | null;
  testsPassed?: number | null;
  testsFailed?: number | null;
  averageScore?: number | null;
  bestScore?: number | null;
  worstScore?: number | null;
}

@Component({
  selector: 'app-stats-breakdown-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './stats-breakdown-card.component.html',
  styleUrl: './stats-breakdown-card.component.css',
})
export class StatsBreakdownCardComponent implements OnInit {
  @Input() titleKey: string = '';
  @Input() titleIcon: string = 'fa-solid fa-graduation-cap';
  @Input() titleIconColor: string = '#696cff';
  @Input() stats: BreakdownStats | null = null;
  @Input() includeExtremes: boolean = false;

  private mounted = signal(false);

  ngOnInit(): void {
    setTimeout(() => this.mounted.set(true), 0);
  }

  get avg(): number {
    return this.stats?.averageScore != null
      ? Math.round(this.stats.averageScore)
      : 0;
  }

  get hasData(): boolean {
    return (this.stats?.testsTaken ?? 0) > 0;
  }

  private get total(): number { return this.stats?.testsTaken ?? 0; }

  get passedRatio(): number {
    return this.total > 0 ? ((this.stats?.testsPassed ?? 0) / this.total) * 100 : 0;
  }
  get failedRatio(): number {
    return this.total > 0 ? ((this.stats?.testsFailed ?? 0) / this.total) * 100 : 0;
  }
  get successRate(): number {
    return Math.round(this.passedRatio);
  }

  /** Animated widths : 0 → real value once the first paint is committed. */
  get displayedPassedRatio(): number { return this.mounted() ? this.passedRatio : 0; }
  get displayedFailedRatio(): number { return this.mounted() ? this.failedRatio : 0; }
}
